import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { isBankAccountAllowed } from '@model/BankAccount'

export const useWithdrawalBankAccounts = (enabled: boolean) => {
  const apiClient = useApiClient(ClientApiClient)

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.profile.bankAccounts(),
    queryFn: () => apiClient.getBankAccounts(),
    enabled,
  })

  const bankAccounts = useMemo(() => (data ?? []).filter(isBankAccountAllowed), [data])

  return {
    bankAccounts,
    isBankAccountsLoading: isLoading,
  }
}
